import { render, staticRenderFns } from "./filter-categories-dedicated.vue?vue&type=template&id=64fb456e"
import script from "./filter-categories-dedicated.vue?vue&type=script&lang=js"
export * from "./filter-categories-dedicated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports